export const FETCH_ORGANIZATIONS_REQUEST = "FETCH_ORGANIZATIONS_REQUEST"
export const FETCH_ORGANIZATIONS_SUCCESS = "FETCH_ORGANIZATIONS_SUCCESS"
export const FETCH_ORGANIZATIONS_FAILURE = "FETCH_ORGANIZATIONS_FAILURE"

export const CREATE_ORGANIZATION_REQUEST = "CREATE_ORGANIZATION_REQUEST"
export const CREATE_ORGANIZATION_SUCCESS = "CREATE_ORGANIZATION_SUCCESS"
export const CREATE_ORGANIZATION_FAILURE = "CREATE_ORGANIZATION_FAILURE"

export const UPDATE_ORGANIZATION_REQUEST = "UPDATE_ORGANIZATION_REQUEST"
export const UPDATE_ORGANIZATION_SUCCESS = "UPDATE_ORGANIZATION_SUCCESS"
export const UPDATE_ORGANIZATION_FAILURE = "UPDATE_ORGANIZATION_FAILURE"

export const CLEAR_ORGANIZATION_STATE = "CLEAR_ORGANIZATION_STATE"

export const SET_ACTIVE_ORGANIZATION = "SET_ACTIVE_ORGANIZATION"
export const RESET_ORG_FLAG = "RESET_ORG_FLAG"

export const SET_CONSOLIDATED_VIEW = "SET_CONSOLIDATED_VIEW"
